// extracted by mini-css-extract-plugin
module.exports = {"isCenter":"_1ix5wusD","isRight":"MTcnV3Xi"};